import { z } from 'zod';
export const createOrgSchema = z.object({
    name: z.string().min(1).max(255),
    primary_domain: z.string().max(255)
        .refine(val => !val || !/^(https?:\/\/|www\.)/i.test(val), {
        message: 'Enter domain only (e.g., example.com) — remove https:// or www.',
    })
        .refine(val => !val || /^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/.test(val), {
        message: 'Enter a valid domain (e.g., example.com)',
    })
        .optional(),
    settings: z.record(z.unknown()).optional(),
    location: z.object({
        name: z.string().min(1).max(255),
        address_line1: z.string().max(255).optional(),
        city: z.string().max(100).optional(),
        state: z.string().max(50).optional(),
        zip: z.string().max(20).optional(),
        phone: z.string().max(20)
            .refine(val => !val || /^\(\d{3}\) \d{3}-\d{4}$/.test(val), {
            message: 'Phone must be (XXX) XXX-XXXX format',
        })
            .optional(),
        email: z.string().email().max(254).optional(),
    }).optional(),
});
export const updateOrgConfigSchema = z.record(z.unknown());
export const orgTransitionSchema = z.object({
    to_status: z.enum(['prospect', 'in_build', 'approval_needed', 'live', 'pending_cancelled', 'cancelled']),
    reason: z.string().optional(),
});
//# sourceMappingURL=organization.js.map